import { useEffect, useState } from "react"

/**
 * Момент «сейчас», обновляемый раз в минуту.
 *
 * ПОЧЕМУ НЕ setInterval(60000). Интервал стартует от момента подключения и потому
 * срабатывает в произвольную секунду: подпись «у вас сейчас 14:40» меняется на 14:41
 * через сорок секунд после того, как минута действительно кончилась. Здесь первый таймер
 * заводится ровно до границы минуты, и дальше время на экране совпадает с часами
 * на стене — тем самым, по которым администратор называет клиенту время.
 *
 * Разрешение именно минутное: секундная стрелка в кабинете не нужна никому, а перерисовка
 * оболочки раз в секунду обошлась бы в постоянно занятую вкладку.
 */
export function useMinuteTick(): Date {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null

    const schedule = (): void => {
      const current = new Date()
      const msToNextMinute = 60000 - (current.getSeconds() * 1000 + current.getMilliseconds())
      timer = setTimeout(() => {
        setNow(new Date())
        schedule()
      }, msToNextMinute)
    }

    schedule()
    return () => {
      if (timer !== null) clearTimeout(timer)
    }
  }, [])

  return now
}
